import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import RelatedPages from '../components/RelatedPages';
import { getPublicAssetPath } from '../config';

const Support: React.FC = () => {
  const [activeTab, setActiveTab] = useState('contact');
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const { darkMode } = useTheme();

  const handleBack = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
    } else {
      navigate('/');
    }
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header */}
        <div className="mb-8">
          <button 
            onClick={handleBack}
            className={`inline-flex items-center text-sm mb-6 transition-colors ${
              darkMode ? 'text-violet-400 hover:text-violet-300' : 'text-violet-600 hover:text-violet-700'
            }`}
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            Kembali ke Dashboard
          </button>
          <div className="flex items-center justify-center mb-6">
            <img 
              src={getPublicAssetPath('/le_long.png')} 
              alt="Legitimu Logo" 
              className="h-12 transition-all duration-300"
              style={darkMode ? { filter: 'brightness(0) invert(1)' } : { filter: 'none' }}
            />
          </div>
          <h1 className={`text-3xl font-bold text-center mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Support</h1>
          <p className={`text-sm text-center ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Kami siap membantu Anda</p>
        </div>

        {/* Tabs */}
        <div className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} rounded-lg border shadow-sm mb-6 transition-colors duration-300`}>
          <div className={`border-b ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}>
            <nav className="flex">
              <button
                onClick={() => setActiveTab('contact')}
                className={`flex-1 px-6 py-4 text-sm font-semibold transition-colors ${
                  activeTab === 'contact'
                    ? 'text-violet-600 border-b-2 border-violet-600'
                    : darkMode 
                      ? 'text-gray-400 hover:text-gray-200' 
                      : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <i className="fa-solid fa-envelope mr-2"></i>
                Kontak Kami
              </button>
              <button
                onClick={() => setActiveTab('faq')}
                className={`flex-1 px-6 py-4 text-sm font-semibold transition-colors ${
                  activeTab === 'faq'
                    ? 'text-violet-600 border-b-2 border-violet-600'
                    : darkMode 
                      ? 'text-gray-400 hover:text-gray-200' 
                      : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <i className="fa-solid fa-question-circle mr-2"></i>
                FAQ
              </button>
            </nav>
          </div>
        </div>

        {/* Content */}
        {activeTab === 'contact' && (
          <div className={`${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} rounded-lg border shadow-sm p-8 space-y-6 transition-colors duration-300`}>
            <div>
              <h2 className={`text-2xl font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Hubungi Tim Support</h2>
              <p className={`leading-relaxed mb-6 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Tim support kami siap membantu Anda dengan pertanyaan, masalah teknis, atau permintaan bantuan lainnya. Pilih metode kontak yang paling nyaman untuk Anda.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-6">
              <div className={`p-6 border rounded-lg transition-colors duration-300 ${
                darkMode ? 'bg-violet-900/30 border-violet-700' : 'bg-violet-50 border-violet-200'
              }`}>
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-violet-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="fa-solid fa-envelope text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className={`text-lg font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Email Support</h3>
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Respon dalam 24 jam</p>
                  </div>
                </div>
                <p className={`font-medium ${darkMode ? 'text-violet-300' : 'text-violet-700'}`}>support@legitimu.com</p>
                <p className={`text-sm mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Untuk pertanyaan umum dan bantuan teknis</p>
              </div>

              <div className={`p-6 border rounded-lg transition-colors duration-300 ${
                darkMode ? 'bg-violet-900/30 border-violet-700' : 'bg-violet-50 border-violet-200'
              }`}>
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-violet-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="fa-solid fa-phone text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className={`text-lg font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Phone Support</h3>
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Senin - Jumat, 09:00 - 17:00 WIB</p>
                  </div>
                </div>
                <p className={`font-medium ${darkMode ? 'text-violet-300' : 'text-violet-700'}`}>+62 (21) 1234-5678</p>
                <p className={`text-sm mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Untuk bantuan langsung dan urgent</p>
              </div>

              <div className={`p-6 border rounded-lg transition-colors duration-300 ${
                darkMode ? 'bg-violet-900/30 border-violet-700' : 'bg-violet-50 border-violet-200'
              }`}>
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-violet-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="fa-solid fa-comments text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className={`text-lg font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Live Chat</h3>
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Tersedia di aplikasi</p>
                  </div>
                </div>
                <p className={`font-medium ${darkMode ? 'text-violet-300' : 'text-violet-700'}`}>Chat dengan kami</p>
                <p className={`text-sm mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Untuk bantuan real-time</p>
              </div>

              <div className={`p-6 border rounded-lg transition-colors duration-300 ${
                darkMode ? 'bg-violet-900/30 border-violet-700' : 'bg-violet-50 border-violet-200'
              }`}>
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-violet-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="fa-solid fa-building text-white text-xl"></i>
                  </div>
                  <div>
                    <h3 className={`text-lg font-semibold ${darkMode ? 'text-white' : 'text-gray-900'}`}>Office Address</h3>
                    <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Kunjungi kami</p>
                  </div>
                </div>
                <p className={`font-medium ${darkMode ? 'text-violet-300' : 'text-violet-700'}`}>[Alamat Perusahaan]</p>
                <p className={`text-sm mt-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Jakarta, Indonesia</p>
              </div>
            </div>

            <div className={`mt-8 p-6 border rounded-lg transition-colors duration-300 ${
              darkMode ? 'bg-gray-700 border-gray-600' : 'bg-gray-50 border-gray-200'
            }`}>
              <h3 className={`text-lg font-semibold mb-3 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Kirim Pesan</h3>
              <form className="space-y-4">
                <div>
                  <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Nama</label>
                  <input
                    type="text"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-violet-500 ${
                      darkMode
                        ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-500'
                        : 'border-gray-300'
                    }`}
                    placeholder="Nama Anda"
                  />
                </div>
                <div>
                  <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Email</label>
                  <input
                    type="email"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-violet-500 ${
                      darkMode
                        ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-500'
                        : 'border-gray-300'
                    }`}
                    placeholder="email@example.com"
                  />
                </div>
                <div>
                  <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Subjek</label>
                  <input
                    type="text"
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-violet-500 ${
                      darkMode
                        ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-500'
                        : 'border-gray-300'
                    }`}
                    placeholder="Subjek pesan"
                  />
                </div>
                <div>
                  <label className={`block text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>Pesan</label>
                  <textarea
                    rows={5}
                    className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-violet-500 focus:border-violet-500 ${
                      darkMode
                        ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-500'
                        : 'border-gray-300'
                    }`}
                    placeholder="Tulis pesan Anda di sini..."
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="w-full px-4 py-2 bg-violet-600 text-white text-sm font-medium rounded-lg hover:bg-violet-700"
                >
                  <i className="fa-solid fa-paper-plane mr-2"></i>
                  Kirim Pesan
                </button>
              </form>
            </div>
          </div>
        )}

        {activeTab === 'faq' && (
          <div className={`rounded-lg border shadow-sm p-8 space-y-6 transition-colors duration-300 ${
            darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
          }`}>
            <div>
              <h2 className={`text-2xl font-semibold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Frequently Asked Questions</h2>
              <p className={`leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Temukan jawaban untuk pertanyaan yang sering diajukan tentang Legitimu.
              </p>
            </div>

            <div className="space-y-4">
              <div className={`border rounded-lg p-6 transition-colors duration-300 ${
                darkMode ? 'border-gray-700' : 'border-gray-200'
              }`}>
                <h3 className={`text-lg font-semibold mb-2 flex items-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className="fa-solid fa-circle-question text-violet-600 mr-3"></i>
                  Bagaimana cara membuat agreement baru?
                </h3>
                <p className={`leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  Klik tombol "New Request" di Dashboard atau Agreements Board, kemudian isi formulir dengan informasi yang diperlukan. Setelah submit, agreement akan masuk ke workflow untuk diproses.
                </p>
              </div>

              <div className={`border rounded-lg p-6 transition-colors duration-300 ${
                darkMode ? 'border-gray-700' : 'border-gray-200'
              }`}>
                <h3 className={`text-lg font-semibold mb-2 flex items-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className="fa-solid fa-circle-question text-violet-600 mr-3"></i>
                  Bagaimana cara mengubah status agreement?
                </h3>
                <p className={`leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  Status agreement biasanya berubah secara otomatis berdasarkan workflow. Namun, administrator atau user dengan permission tertentu dapat mengubah status secara manual melalui halaman detail agreement.
                </p>
              </div>

              <div className={`border rounded-lg p-6 transition-colors duration-300 ${
                darkMode ? 'border-gray-700' : 'border-gray-200'
              }`}>
                <h3 className={`text-lg font-semibold mb-2 flex items-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className="fa-solid fa-circle-question text-violet-600 mr-3"></i>
                  Apakah saya bisa mengunduh agreement yang sudah selesai?
                </h3>
                <p className={`leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  Ya, Anda dapat mengunduh agreement dalam berbagai format (PDF, Word) dari halaman detail agreement. Fitur download tersedia untuk agreement yang sudah dalam status APPROVED atau RELEASED.
                </p>
              </div>

              <div className={`border rounded-lg p-6 transition-colors duration-300 ${
                darkMode ? 'border-gray-700' : 'border-gray-200'
              }`}>
                <h3 className={`text-lg font-semibold mb-2 flex items-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className="fa-solid fa-circle-question text-violet-600 mr-3"></i>
                  Bagaimana cara menambahkan anggota tim ke agreement?
                </h3>
                <p className={`leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  Di Drafting Workspace, buka bagian "Team Members" dan klik tombol "Add Member". Pilih user dari daftar dan tentukan role mereka dalam proses drafting.
                </p>
              </div>

              <div className={`border rounded-lg p-6 transition-colors duration-300 ${
                darkMode ? 'border-gray-700' : 'border-gray-200'
              }`}>
                <h3 className={`text-lg font-semibold mb-2 flex items-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className="fa-solid fa-circle-question text-violet-600 mr-3"></i>
                  Apa yang harus saya lakukan jika lupa password?
                </h3>
                <p className={`leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  Gunakan fitur "Forgot Password" di halaman login. Anda akan menerima email dengan link untuk mereset password. Jika tidak menerima email, periksa folder spam atau hubungi administrator.
                </p>
              </div>

              <div className={`border rounded-lg p-6 transition-colors duration-300 ${
                darkMode ? 'border-gray-700' : 'border-gray-200'
              }`}>
                <h3 className={`text-lg font-semibold mb-2 flex items-center ${darkMode ? 'text-white' : 'text-gray-900'}`}>
                  <i className="fa-solid fa-circle-question text-violet-600 mr-3"></i>
                  Bagaimana cara menggunakan template?
                </h3>
                <p className={`leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                  Di halaman Templates, pilih template yang sesuai dengan kebutuhan Anda. Klik "Use Template" untuk membuat agreement baru berdasarkan template tersebut. Template akan di-copy ke workspace Anda untuk diedit sesuai kebutuhan.
                </p>
              </div>
            </div>

            <div className={`mt-8 p-6 border rounded-lg transition-colors duration-300 ${
              darkMode ? 'bg-violet-900/30 border-violet-700' : 'bg-violet-50 border-violet-200'
            }`}>
              <h3 className={`text-lg font-semibold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>Masih punya pertanyaan?</h3>
              <p className={`mb-4 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                Jika pertanyaan Anda belum terjawab di FAQ, silakan hubungi tim support kami melalui halaman Kontak.
              </p>
              <button
                onClick={() => setActiveTab('contact')}
                className="px-4 py-2 bg-violet-600 text-white text-sm font-medium rounded-lg hover:bg-violet-700"
              >
                Hubungi Support
              </button>
            </div>
          </div>
        )}

        {/* Related Pages */}
        <RelatedPages currentPage="support" />

        {/* Footer Actions */}
        <div className="mt-8 text-center">
          <button 
            onClick={handleBack}
            className="inline-flex items-center px-4 py-2 bg-violet-600 text-white text-sm font-medium rounded-lg hover:bg-violet-700"
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            Kembali ke Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default Support;

